import humps from "humps";

import Api from "./api.service";

class LicenseBundles {
  static getBundles(tenantSlug, data) {
    const params = humps.decamelizeKeys(data);

    return Api.get(`/api/v1/tenants/${tenantSlug}/license_bundles`, {
      params: { include: "license_bundle_prices", ...params }
    });
  }

  static get(slug, tenantSlug) {
    return Api.get(`/api/v1/tenants/${tenantSlug}/license_bundles/${slug}`, {
      params: { include: "license_bundle_prices" }
    });
  }

  static create(BundleAttributes, tenantSlug) {
    const payload = {
      data: {
        type: "license_bundles",
        attributes: BundleAttributes
      }
    };

    return Api.post(`/api/v1/tenants/${tenantSlug}/license_bundles`, payload);
  }

  static put(slug, tenantSlug, licenseBundleAttributes) {
    const payload = {
      data: {
        type: "license_bundles",
        id: slug,
        attributes: licenseBundleAttributes
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/license_bundles/${slug}`, payload);
  }

  static createPrice(bundleSlug, tenantSlug, bundlePricesAttributes) {
    const { amount, currency } = bundlePricesAttributes;
    const payload = {
      data: {
        type: "license_bundle_prices",
        attributes: {
          amount,
          currency
        },
        relationships: {
          license_bundle: {
            data: {
              id: bundleSlug,
              type: "license_bundles"
            }
          }
        }
      }
    };

    return Api.post(`/api/v1/tenants/${tenantSlug}/license_bundle_prices`, payload);
  }

  static updatePrice(slug, tenantSlug, bundlePricesAttributes) {
    const { amount, currency } = bundlePricesAttributes;

    const payload = {
      data: {
        type: "license_bundle_prices",
        id: slug,
        attributes: {
          amount,
          currency
        }
      }
    };

    return Api.put(`/api/v1/tenants/${tenantSlug}/license_bundle_prices/${slug}`, payload);
  }

  static deletePrice(slug, tenantSlug) {
    return Api.delete(`/api/v1/tenants/${tenantSlug}/license_bundle_prices/${slug}`);
  }
}

const LicenseBundlesService = Object.freeze(LicenseBundles);

export default LicenseBundlesService;
